const { getElement } = window.BAO.Utils
class SearchForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.isOpen = false
    this.setupListeners()
    this.modalElement = this.externalEls.QuickBuyModal
  }

  setupListeners () {
    this.handleSearchInput = this.handleSearchInput.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)
    this.handleAddToCartClick = this.handleAddToCartClick.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    this.openSearch = this.openSearch.bind(this)

    this.listeners.add(this.els.input.element, 'click', this.handleSearchInput)
    this.listeners.add(this.els.input.element, 'input', this.openSearch)

    if (this.els.trigger.exists) {
      this.listeners.add(
        this.els.trigger.element,
        'click',
        this.handleSearchInput,
      )
    }

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.handleSearchInput,
    )

    document.body.addEventListener('click', this.handleBodyClick)
    document.addEventListener('quickBuy:added', this.handleAddToCartClick)
    document.addEventListener('keydown', this.handleKeydown, true)
  }

  handleKeydown (event) {
    if (event.key !== 'Escape') return

    // Let the quick buy modal take the first Escape on its own
    if (document.querySelector('quick-buy-modal[aria-hidden="false"]')) return

    this.closeSearch()
  }

  handleSearchInput (event) {
    event.stopPropagation()
    this.openSearch()
  }

  openSearch () {
    if (this.isOpen) return
    this.isOpen = true

    this.scrollPosition = window.scrollY
    document.body.style.setProperty(
      '--SearchOverlayTop',
      `${this.scrollPosition}px`,
    )

    document.body.classList.add(
      'util-SiteOverflowed',
      'util-Search-open',
      'util-SearchLocked',
    )

    this.els.input.element.focus()
  }

  handleAddToCartClick (event) {
    const searchResultsContainer = document.querySelector(
      '.kuQuickSearchResultsContainer',
    )
    if (!searchResultsContainer) return

    this.closeSearch()
    searchResultsContainer.style.cssText = 'display: none !important'
  }

  handleBodyClick (event) {
    this.modalElement = getElement(this.externalEls.QuickBuyModal.selector)

    if (
      !event.target.closest('.qb-Modal') &&
      !event.target.closest('.klevuWrap') &&
      !this.els.input.elements.includes(event.target)
    ) {
      this.closeSearch()
    }
  }

  closeSearch () {
    if (!this.isOpen) return
    this.isOpen = false

    document.body.classList.remove(
      'util-SiteOverflowed',
      'util-Search-open',
      'util-SearchLocked',
    )
    document.body.style.removeProperty('--SearchOverlayTop')

    window.scrollTo(0, this.scrollPosition || 0)

    const searchResultsContainer = document.querySelector(
      '.kuQuickSearchResultsContainer',
    )
    if (!searchResultsContainer) return

    searchResultsContainer.style.cssText = 'display: none !important'
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm)
}
